import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { useUpgradeContext } from 'src/hooks/useUpgradeContext';
import { mergeQueryParams } from 'src/lib/routing';

export const ServiceRangeUnavailable = () => {
  const location = useLocation();
  const { upgradeRoute } = useUpgradeContext();

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <div className="font-bold">Data out of range</div>
      <div className="p-3 text-center text-sm leading-normal text-secondary">
        Part of the data you’re trying to view is more than 24 hours old.
        <br />
        There is a 24-hour data retention policy on the Apollo Free plan.
        <br />
        To access earlier data, upgrade to Enterprise.
      </div>
      <Link className="p-3 font-semibold underline" to={upgradeRoute}>
        Upgrade to Enterprise
      </Link>
      <Link
        className="p-3 font-bold underline"
        to={{
          search: mergeQueryParams(location.search, { range: 'lastDay' }),
        }}
      >
        Take me to the last 24 hours.
      </Link>
    </div>
  );
};
